<template>
  <div class="setting-notifications-page">
    <ins-selector v-model="selectPublisherId"></ins-selector>
    <div class="right-container" v-if="selectPublisherId">
      <div class="header-title">Notifications</div>
      <div class="main-container">
        <div class="email-push-info">
          <div class="title">Email Notifications</div>
          <div class="selector-item">
            <div class="left-container">
              <div class="title">Post status</div>
            </div>
            <el-switch
              @change="notificationChange('emailPostStatus')"
              :value="notification.emailPostStatus"
            >
            </el-switch>
          </div>
          <div class="selector-item">
            <div class="left-container">
              <div class="title">Failure alert</div>
              <div class="tip">No auto post, missed post, login problem</div>
            </div>
            <el-switch
              @change="notificationChange('emailFailureAlert')"
              :value="notification.emailFailureAlert"
            >
            </el-switch>
          </div>
        </div>
        <div class="email-push-info">
          <div class="title">Push Notifications</div>
          <!-- <div class="selector-item">
            <div class="left-container">
              <div class="title">Daily analytics report</div>
            </div>
            <el-switch @change="notificationChange('pushDailyAnalyticsReport')"
                       :value="notification.pushDailyAnalyticsReport">
            </el-switch>
          </div> -->
          <div class="selector-item">
            <div class="left-container">
              <div class="title">Post status</div>
            </div>
            <el-switch
              @change="notificationChange('pushPostStatus')"
              :value="notification.pushPostStatus"
            >
            </el-switch>
          </div>
          <div class="selector-item">
            <div class="left-container">
              <div class="title">Failure alert</div>
              <div class="tip">No auto post, missed post, login problem</div>
            </div>
            <el-switch
              @change="notificationChange('pushFailureAlert')"
              :value="notification.pushFailureAlert"
            >
            </el-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import insSelector from "../../components/common/instagram_selector/Selector";
import { updatePublisherNotification } from "../../service/publisher";
import { showErrorMsg } from "../../utils/errors";
import _ from "lodash";

export default {
  name: "SettingNotificationsPage",
  components: { insSelector },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    publisher() {
      return this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.selectPublisherId
      );
    },
  },
  data() {
    return {
      selectPublisherId: "",
      switchPublisher: false,
      notification: {
        emailPostStatus: false,
        emailFailureAlert: false,
        pushDailyAnalyticsReport: false,
        pushPostStatus: false,
        pushFailureAlert: false,
      },
    };
  },
  methods: {
    async notificationChange(type) {
      const loading = this.$loading();
      try {
        let notification = _.cloneDeep(this.notification);
        notification[type] = !this.notification[type];
        await updatePublisherNotification({
          publisherId: this.selectPublisherId,
          notification,
        });
        this.notification = this.publisher.notification;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  watch: {
    selectPublisherId(val) {
      const selectPublisher = this.user.linkedInstagramList.find(
        (l) => l.publisherId === val
      );
      this.notification = selectPublisher.notification;
      this.switchPublisher = true;
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.setting-notifications-page {
  height: 100vh;
  display: flex;
  flex: 1;
  .right-container {
    flex: 1;
    .header-title {
      font-size: 18px;
      height: 80px;
      display: flex;
      align-items: center;
      font-weight: 500;
      padding-left: 40px;
      border-bottom: 1px solid @border-color;
    }
    .main-container {
      flex: 1;
      padding: 20px 40px;
      max-width: 600px;
      .title {
        font-size: 20px;
        font-weight: 500;
      }
      .selector-item {
        display: flex;
        align-items: center;
        height: 44px;
        margin-top: 10px;
        .left-container {
          flex: 1;
          line-height: 1;
          .title {
            font-size: 16px;
          }
          .tip {
            font-size: 14px;
            color: @font-color-gray;
            margin-top: 5px;
          }
        }
      }
      .email-push-info {
        border-bottom: 1px solid @border-color;
        padding-bottom: 20px;
        padding-top: 30px;
      }
    }
  }
}
</style>
